import storage from "@/common/ts/stroage";
var S = new storage();

const user = {
  state: {
    /**
     * 合约列表
     * 数组对象结构参考 currentCodeObj
     */
    certifyId:'',
    coinIp:{
      name:'',
      ip:''
    },
    faceInfo:{
    },
    codeList: [],
    token: "",
    status: 0, //0 未开通 1开通 2冻结(不能提交订单)
    followSign: localStorage.getItem('followSign') || 0, // 跟单协议开通 (0=>未开通，1=>开通)
    id: 0,
    login_state_end: false,
    userInfo: {},
    leaderId: "", //跟单页面是否直接进入跟单设置 老师id
    userMenu: window.systemOut ? null : S.getStorageSync("userMenu") || null, //用户信息
    currentCodeObj: {
      name: '-',
      status: 'online',
      base: '-',
      quote: '-',
      symbol: '-',
      symbolId: '0',
      priceDigits: '0',
      biDigits: '0',
      numDigits: '0',
      price: '-',
      priceChange: '-',
      priceHigh: '-',
      priceLow: '-',
      priceSign: '-',
      priceExponent: '-',
      fundsRate: '-',
      closeTime: '-',
      data: null,
    },
    loginAreaCode: '86',
    loginPhone: '',
    loginEmail: '',
    authentication: {},
		/**
   * 对话框设置的全局state
   */
		dialogState: {
			//全仓或者逐仓模式
			allinOrPartStore: JSON.parse(localStorage.getItem('allinOrPartStore_DialogState')) || {
				allinOrPart: 'part', //0 'part' 和 1 'allin'
			},
			//合仓或者分仓模式
			heCangOrFenCangStore: JSON.parse(localStorage.getItem('heCangOrFenCangStore_DialogState')) || {
				heCangOrFenCang: 'fenCang', //0 'heCang' 和 1 'fenCang'
			},
			//张/USDT/bi 单位切换 默认usdt
			sheetOrCoinStore: JSON.parse(localStorage.getItem('sheetOrCoinStore_DialogState')) || {
				sheetOrCoin: 'coin', //'sheet' 和 'coin' 、'bi'
			},
			//lever杠杆倍数
			leverRatioNumStore: {
				leverRatioNum: 20,
			},
			//首屏协议
			protocolTextStore: JSON.parse(localStorage.getItem('protocolTextStore_DialogState')) || {
				neverTips: false,
			},
			//成交类型切换
			limitedOrMarketStore: JSON.parse(localStorage.getItem('limitedOrMarketStore_DialogState')) || {
				limitedOrMarket: 'limitedPrice', // 'limitedPrice' 和 'marketPrice'
				neverTips: false,
			},
		},
  },
  mutations: {
    SET_COINIP(state, value) {
      state.coinIp = value;
    },
    SET_faceInfo(state, value) {
      state.faceInfo = value;
    },
    
    SET_certifyId(state, value) {
      state.certifyId = value;
    },
    
    SET_TOKEN(state, value) {
      state.token = value;
    },
    /** 401 / 强制登出：与 storage 一致清空内存态，避免仍显示已登录 */
    CLEAR_AUTH_SESSION(state) {
      state.userMenu = null;
      state.token = '';
      state.login_state_end = false;
    },
    //设置合约币对列表
    setCodeList(state, list) {
      state.codeList = list;
    },
    getUserMenu: (state, item) => {
      state.userMenu = { ...(state.userMenu || {}), ...item };
    },
    CHANGE_LOGIN_STATE_END: (state) => {
      state.login_state_end = true;
    },
    SET_URLPARAM(state, value) {
      state.token = value.sign;
      state.status = value.situation; //0 未开通 1开通 2冻结(不能提交订单)
    },
    SET_USERINFO(state, value) {
      state.userInfo = value;
    },
    SET_LEADERID(state, value) {
      state.leaderId = value;
    },
		//张/USDT/币 单位切换
		setSheetOrCoinStore(state, paylod) {
			state.dialogState.sheetOrCoinStore = {
				...(state.dialogState.sheetOrCoinStore || {}),
				...paylod,
			};
			localStorage.setItem(
				'sheetOrCoinStore_DialogState',
				JSON.stringify(state.dialogState.sheetOrCoinStore),
			);
		},
    //更改合约币对列表
    updateCodeList(state, data) {
      for (let i = 0; i < state.codeList.length; i++) {
        if (state.codeList[i].base == data.base) {
          state.codeList[i] = {
            ...(state.codeList[i] || {}),
            ...data,
          };
          //更新当前币对展示信息
          if (state.codeList[i].base == state.currentCodeObj.base) {
            state.currentCodeObj = {
              ...(state.currentCodeObj || {}),
              ...state.codeList[i],
            };
          }
          break;
        }
      }
    },
    // 设置跟单协议状态
    SET_FOLLOW_SIGN(state, value) {
      state.followSign = value
      localStorage.setItem('followSign', value)
    },
    // 清除跟单协议状态
    REMOVE_FOLLOW_SIGN(state) {
      state.followSign = 0
      state.status = 0
      localStorage.removeItem('followSign')
    },
    // 获取当前用户手机好和区号
    SET_LOGIN_INFO(state, {phone, areaCode, email}) {
      state.loginPhone = phone
      state.loginAreaCode = areaCode
      state.loginEmail = email
    },
    SET_AUTHENTICATION(state, params) {
      state.authentication = {...params}
    }
  },
  actions: {
    getUserMenu: ({ commit }, item) => {
      commit("getUserMenu", item);
      commit("CHANGE_LOGIN_STATE_END");
      S.setStorageSync("userMenu", item);
    },
  },
  getters: {
    getUserInfoFolloer: function (state){
      return state.userInfo
    },
    getCoinIp: function (state){
      return state.coinIp
    },
    getFaceInfo: function (state){
      return state.faceInfo
    },
    getCertifyId: function (state) {
      return state.certifyId;
    },
    getTokens: function (state) {
      return state.token;
    },
    getCodeDataByBase: (state) => (base) => {
      // console.log('state.codeList:', state.codeList)
      return state.codeList.find((code) => code.base === base);
    },
    getContartStutas: function (state) {
      return state.status;
    },
    isLogin: function (state) {
      if (state.userMenu && state.userMenu.id) return true;
      if (state.token && String(state.token).trim()) return true;
      try {
        if (typeof localStorage !== 'undefined') {
          const x = localStorage.getItem('x-token');
          if (x && String(x).trim()) return true;
        }
      } catch (e) {
        /* ignore */
      }
      return false;
    },
    getId: function (state) {
      return state.id || null;
    },
    getLoginStateEnd(state) {
      return state.login_state_end;
    },
    getUserInfo: function (state) {
      return state.userMenu;
    },
    //单位切换
    getSheetOrCoinStore: (state) => {
      return state.dialogState.sheetOrCoinStore;
    },
    getFollowSign: (state) => {
      return state.followSign;
    },
    getLoginInfo: (state) => {
      return {phone: state.loginPhone, areaCode: state.loginAreaCode, email: state.loginEmail}
    },
    getAuthentication(state) {
      return state.authentication
    }
  },
};

export default user;



// WEBPACK FOOTER //
// ./src/store/user/index.js